<template>
  <div class="footer">
    <hr
      style="
        max-width: 1100px;
        background-color: black;
        height: 1px;
        border: none;
      "
    />
  </div>
</template>

<script>
export default {};
</script>

<style>
.footer {
  margin-top: 50px;
  padding-bottom: 100px;
}
</style>